import React, { Dispatch, SetStateAction, useRef } from "react";
import { useAppDispatch } from "../../../../hooks/useAppDispatch";
import { calculateGross } from "../../CustomerModule/Components/CustomerBooking/utils/booking.utils";
import { CapacityIcon, DimesionsIcon } from "../../../constants/icons";
import { setIntraCity } from "../../../../redux/slices/customerBooking/customerBookingSlice";

// type
export type IntraCityRateEstimateItemType = {
  maxCapacity?: number;
  assetSubType: {
    name: string;
    assetType: {
      assetName: string;
      _id: string;
      sideImage?: string;
      topImage?: string;
    };
  };
  dimensions?: {
    l: number;
    b: number;
    h: number;
  } | null;
  capacity?: number | null;
  distance: number;
  durations: number;
  _id: string;
  availableFreeMinutes: number;
  perMinuteCharge: number;
  price: number;
};

type IntraCityRatesProps = {
  arr: IntraCityRateEstimateItemType[];
  selectedItem: number;
  setSelectedItem: Dispatch<SetStateAction<number>>;
  // onItemClick?: (item: IntraCityRateEstimateItemType) => void;
  setSelectedAssetType?: Dispatch<
    SetStateAction<IntraCityRateEstimateItemType>
  >;
  selectedAssetType?: IntraCityRateEstimateItemType;
  selectedVehicle?: IntraCityRateEstimateItemType;
  setSelectedVehicle?: Dispatch<SetStateAction<IntraCityRateEstimateItemType>>;
};

const IntraCityRates = ({
  arr,
  selectedItem,
  setSelectedItem,
  // onItemClick,
  setSelectedAssetType,
  setSelectedVehicle
}: IntraCityRatesProps) => {
  const dispatch = useAppDispatch<any>();
  const itemRefs = useRef<(HTMLDivElement | null)[]>([]);

  let ArrData: any = [];

  arr.map((item: any) => {
    if (item?.assetSubType?.assetType?.sideImage && item?.assetSubType?.name) {
      ArrData?.push(item);
    }
  })

  ArrData.sort((a: any, b: any) => a.price - b.price);


  return (
    <div className="grid gap-1">
      {ArrData &&
        Array.isArray(ArrData) &&
        ArrData.length > 0 &&
        ArrData.map((item, index: number) => {
          const isSelected = selectedItem === index;
          return (
            <div
              key={index}
              ref={el => itemRefs.current[index] = el}
              className={`intra-city-rate-estimated-item | light-paper fs-link grid gap-4 pointer ${isSelected ? "active" : ""
                }`}
              style={{ scrollMarginTop: 45 }}
              onClick={() => {
                // Scroll to the selected item
                itemRefs.current[index]?.scrollIntoView({
                  block: "center",
                  behavior: "smooth"
                });
                setSelectedItem(index);
                if (setSelectedVehicle) {
                  setSelectedVehicle({ ...item, price: calculateGross(item?.distance, item?.price) });
                }
                if (setSelectedAssetType) {
                  setSelectedAssetType(item);
                }
                dispatch(
                  setIntraCity(["assetSubType", {
                    ...item?.assetSubType,
                  }])
                );
                dispatch(setIntraCity(["gross", item.price]));
              }}
            >
              <div className="flex-between gap-1">
                <div className="fw-600 m-flex-col m-gap-1">
                  <div style={{ width: "100px", height: "100px" }}>
                    {item?.assetSubType?.assetType?.sideImage && (
                      <img
                        src={item?.assetSubType?.assetType?.sideImage}
                        alt="Image"
                        // className="animation-fade-in"
                        style={{ width: "100%", height: "100%" }}
                      />
                    )}
                  </div>
                  {item?.assetSubType?.name || "Vehicle"} {" "} | {" "}
                  {item?.assetSubType?.assetType?.assetName || ""}
                </div>
                {<strong className="px-1 py-4 oval bg-success-50 text-success-900 shadow-small fs-subheading2 as-start">
                  ₹{calculateGross(
                    item?.distance,
                    item?.price
                  )}
                </strong>}
              </div>
              {/* // ATTENTION: Max Capacity & Dimensions are not included in response */}
              {/* <div className="flex flex-wrap ai-center gap-8">
                {(item?.assetTypes?.maxCapacity || item.maxCapacity) && (
                  <p>
                    <CapacityIcon /> {item?.assetSubType.assetType?.maxCapacity || item.maxCapacity || 0}kg
                  </p>
                )}

                {item?.assetSubType.assetType?.dimensions && (
                  <p>
                    <DimesionsIcon /> {item?.assetSubType.assetType?.dimensions?.l}
                    <span>L</span>x{item?.assetSubType.assetType?.dimensions?.b}
                    <span>B</span>x
                    <span>{item?.assetSubType.assetType?.dimensions?.h}H</span>
                  </p>
                )}
              </div> */}
              {item?.assetSubType?.volume &&
                <div className="flex flex-wrap ai-center text-black-100 gap-8">
                  <p>
                    <CapacityIcon className="text-primary-400" />{" "}
                    {item?.assetSubType?.capacity || "0"}{" "}kg
                  </p>
                  {item?.assetSubType ?
                    <p>
                      <DimesionsIcon className="text-primary-400" /> {" "}
                      {`${item?.assetSubType?.volume?.l} ft X 
                        ${item?.assetSubType?.volume?.b} ft X ${item?.assetSubType?.volume?.h} ft`}
                    </p> : null
                  }
                </div>
              }
              {Boolean(item.perMinuteCharge) && (
                <p className="per-min-charge-text text-black-100">
                  First {item.availableFreeMinutes} min waiting time free, then{" "}
                  <span className="per-min-charge">
                    ₹{item.perMinuteCharge}/min
                  </span>
                </p>
              )}
            </div>
          );
        })}
    </div>
  );
};

export default IntraCityRates;
